import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unit2-conclusion',
  templateUrl: './unit2-conclusion.component.html',
  styleUrls: ['./unit2-conclusion.component.css']
})
export class Unit2ConclusionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
